import { useState } from 'react';

export default function Certifications() {
  const [showGIModal, setShowGIModal] = useState(false);

  const certifications = [
    {
      name: 'MSME Certification',
      description: 'Micro, Small & Medium Enterprises',
      icon: 'ri-award-line',
      clickable: false
    },
    {
      name: 'IEC Export Code',
      description: 'Import Export Code: EPTPS3393E',
      icon: 'ri-global-line',
      clickable: false
    },
    {
      name: 'GST Registered Business',
      description: 'GST No: 08EPTPS3393E1Z5',
      icon: 'ri-file-text-line',
      clickable: false
    },
    {
      name: 'GI Registration – Sojat Henna',
      description: 'Geographical Indication Registry of India · Click to view certificate',
      icon: 'ri-medal-line',
      clickable: true
    }
  ];

  return (
    <section id="certifications" className="py-20 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Certifications & Registrations
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Officially recognized and certified business
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {certifications.map((cert, index) => (
            <div
              key={index}
              onClick={cert.clickable ? () => setShowGIModal(true) : undefined}
              className={`bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 text-center ${cert.clickable ? 'cursor-pointer ring-2 ring-orange-200 hover:ring-orange-400' : ''}`}
            >
              <div className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 ${cert.clickable ? 'bg-gradient-to-br from-orange-400 to-orange-600' : 'bg-gradient-to-br from-green-500 to-green-600'}`}>
                <i className={`${cert.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{cert.name}</h3>
              <p className="text-sm text-gray-600">{cert.description}</p>
              {cert.clickable && (
                <span className="inline-flex items-center mt-3 text-xs font-semibold text-orange-500">
                  <i className="ri-eye-line mr-1"></i> View Certificate
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-building-line text-orange-500 mr-3"></i>
                Business Details
              </h4>
              <div className="space-y-3 text-sm text-gray-700">
                <p><strong>Business Type:</strong> Exporter, Manufacturer, Trader</p>
                <p><strong>Organization Type:</strong> Proprietorship</p>
                <p><strong>Year of Establishment:</strong> 2010</p>
                <p><strong>Owner:</strong> Hitesh Sankhla (CEO)</p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-map-pin-line text-orange-500 mr-3"></i>
                Location
              </h4>
              <div className="space-y-3 text-sm text-gray-700">
                <p><strong>City:</strong> Sojat City</p>
                <p><strong>State:</strong> Rajasthan</p>
                <p><strong>Country:</strong> India</p>
                <p><strong>Target Market:</strong> Export & Domestic Wholesale</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GI Certificate Modal */}
      {showGIModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
          onClick={() => setShowGIModal(false)}
        >
          <div
            className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h3 className="text-lg font-bold text-gray-900">GI Registration – Sojat Henna</h3>
              <button
                onClick={() => setShowGIModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer transition-colors"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>
            <div className="p-4">
              <img
                src="https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/7b8d463450f425361f58c43e925e467e.jpeg"
                alt="GI Registration Certificate for Sojat Henna"
                className="w-full h-auto rounded-lg object-top"
              />
              <p className="text-xs text-gray-500 text-center mt-3">
                Geographical Indication Registry of India · GI No. 628 · Certificate No. 372
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
